module.exports = __webpack_public_path__ + "444d9f72cc2b91e4fdfc9b699b9e439c.svg";